import { ReactComponent as InfoIcon } from "../../assets/icons/Info.svg";
import Body2 from "../UI/textFields/Body2";
import labels from "../../utils/labels";
import constraintStyles from "../../styles/constraint.module.css";

const MUTED_TEXT_COLOR = "var(--col-text-secondary)";

const ConstraintExplainer = () => {
  return (
    <aside className={constraintStyles.explainer}>
      <InfoIcon
        width={20}
        height={20}
        className={constraintStyles.explainerIcon}
      />
      <div className={constraintStyles.explainerContent}>
        <h4>{labels.constraintExplainerTitle}</h4>
        <Body2 color={MUTED_TEXT_COLOR}>
          {labels.constraintExplainerIntro}
        </Body2>
        <div className={constraintStyles.explainerTypes}>
          <div className={constraintStyles.explainerType}>
            <h4>{labels.constraintExplainerCategoryTitle}</h4>
            <Body2 color={MUTED_TEXT_COLOR}>
              {labels.constraintExplainerCategoryBody}
            </Body2>
          </div>
          <div className={constraintStyles.explainerType}>
            <h4>{labels.constraintExplainerRelationTitle}</h4>
            <Body2 color={MUTED_TEXT_COLOR}>
              {labels.constraintExplainerRelationBody}
            </Body2>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ConstraintExplainer;
